module.exports = __webpack_public_path__ + "static/img/3823_phase_function_Paper_PointsHejduk_Prediction.3f7503d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3823_phase_function_Paper_PointsHejduk_Prediction.png
// module id = YlhF
// module chunks = 0